<script>
import MineTitle from '../../components/mineTitle.vue';

export default {
    name: "result",
    data() {
        return {
            data: {}
        };
    },
    computed: {
        
    },
    components: {
        MineTitle
    },
    mounted() {
        this.$store.dispatch('getScore').then((result) => {
            if (result.code == 100) { 
                this.data = result.data;
            }
            else if (result.code == 90) { 
                this.$router.replace({
                    path: '/login',
                    query: { redirect: this.$route.fullPath }
                })
            }
        }).catch((err) => {
            
        });
    },
    destroyed() {},
    watch: {},
    methods: {},
};
</script>

<template>
    <div class="result">
        <MineTitle name="My Result" page="Mine / Result"/>
        <div class="info">
            <div class="item flex">
                <div class="name">Name</div>
                <div class="value" v-if="data.user">{{ data.user.name }}</div>
            </div>
            <div class="item flex">
                <div class="name">Student ID</div>
                <div class="value" v-if="data.user">{{ data.user.student_id }}</div>
            </div>
            <div class="item flex">
                <div class="name">Intended Award</div>
                <div class="value" v-if="data.user">{{ data.user.intended_award }}</div>
            </div>
            <!-- <div class="item flex">
                <div class="name">Course</div>
                <div class="value">Qualifi Level 7 Diploma in Human Resource Management</div>
            </div> -->
        </div>
        <MineTitle name="Module Results"/>
        <div class="layout_table table">
            <div class="thead">
                <div class="tr">
                    <div class="td module">Module</div>
                    <div class="td title">Title</div>
                    <div class="td level">Level</div>
                    <div class="td taken">Credit Taken</div>
                    <div class="td achieved">Credit Achieved</div>
                    <div class="td mark">Mark</div>
                    <div class="td grade">Grade</div>
                    <div class="td attempt">Attempt</div>
                </div>
            </div>
            <div class="tbody">
                <div class="tr" v-for="(item, index) in data.list" :key="index">
                    <div class="td module">{{ item.module }}</div>
                    <div class="td title">{{ item.title }}</div>
                    <div class="td level">{{ item.level }}</div>
                    <div class="td taken">{{ item.credit_taken }}</div>
                    <div class="td achieved">{{ item.credit_achieved }}</div>
                    <div class="td mark">{{ item.mark }}</div>
                    <div class="td grade">{{ item.grade }}</div>
                    <div class="td attempt">{{ item.attempt }}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped lang="scss">
.info{
    background: #fff;
    border: 1px solid #c9c9c9;
    border-radius: .05rem;
    padding: .3rem 0;
    margin-bottom: .6rem;
    @media only screen and (max-width: 750px) {
        padding: 0;
    }
    .item{
        padding: 0 .4rem;
        font-size: .2rem;
        color: #666;
        line-height: 2;
        @media only screen and (max-width: 750px) {
            border-bottom: 1px solid #c9c9c9;
            padding: .1rem .2rem;
            line-height: 1.2;
        }
        &:last-child{
            margin-bottom: 0;
            @media only screen and (max-width: 750px) {
                border-bottom: 0;
            }
        }
        .name{
            width: 6.7rem;
            font-weight: 600;
            @media only screen and (max-width: 750px) {
                width: 2.4rem;
            }
        }
        .value{
            flex: 1;
        }
    }
}
.table{
    border: none;
    font-size: .2rem;
    line-height: 1.2;
    @media only screen and (max-width: 750px) {
        display: flex;
        overflow: hidden;
        overflow-x: scroll;
        position: relative;
        border: 1px solid #dcdcdc;
    }
    .thead{
        background: var(--background-color);
        color: #fff;
        border-color: var(--background-color);
        border-radius: .05rem .05rem 0 0;
        @media only screen and (max-width: 750px) {
            border-radius: .05rem 0 0 .05rem;
            border: none;
            position: sticky;
            top: 0;
            left: 0;
            .tr{
                width: 2.1rem;
                // height: 100px;
            }
        }
    }
    .tbody{
        border: 1px solid #dcdcdc;
        @media only screen and (max-width: 750px) {
            display: flex;
            border: none;
            .tr{
                width: 4.6rem;
                border-right: 1px solid #dcdcdc;
                &:last-child{
                    border-right: none;
                }
            }
        }
    }
    .tr{
        @media only screen and (max-width: 750px) {
            flex-direction: column;
            border-bottom: none;
        }
        .td{
            border: none;
            padding: .2rem;
            @media only screen and (max-width: 750px) {
                flex: 1;
                width: auto;
                border-bottom: 1px solid #dcdcdc;
                &:last-child{
                    border-bottom: none;
                }
                &.title{
                    // flex: 10;
                    flex: none;
                    height: 2rem;
                }
            }
        }
    }
    .module{
        flex: none;
        width: 1.8rem;
    }
    .title{
        flex: none;
        width: 4rem;
    }
    .level{
        flex: none;
        width: 1rem;
    }
    .taken{
        flex: 1.6;
    }
    .achieved{
        flex: 2;
    }
}
</style>